import { useTranslation } from 'react-i18next'

import { SparkleIcon } from '@phosphor-icons/react'

import { Button, CombinatorChip, Divider, Text } from '@reveni-io/reveni-ui'

import { findEventConfig } from './TriggerEvent/helpers'
import TriggerEvent from './TriggerEvent/TriggerEvent'
import * as Styles from './styles'

const Trigger = ({
  triggers,
  onChangeTrigger,
  onAddTrigger,
  onRemoveTrigger,
  disabled,
  disabledTriggers = [],
  errors = [],
}) => {
  const { t } = useTranslation()

  const handleChangeEvent = (triggerId, currentType, e) => {
    const nextType = e.target.value
    const previousField = findEventConfig(currentType)?.inputOptions?.field
    const nextField = findEventConfig(nextType)?.inputOptions?.field

    const changes = { type: nextType, values: [] }

    if (previousField) changes[previousField] = null
    if (nextField) changes[nextField] = null

    onChangeTrigger(triggerId, changes)
  }

  const handleChangeValues = (triggerId, e) => {
    onChangeTrigger(triggerId, { values: e.target.value })
  }

  const handleChangeInputValue = (triggerId, currentType, e) => {
    const field = findEventConfig(currentType)?.inputOptions?.field
    if (!field) return

    onChangeTrigger(triggerId, { [field]: e.target.value })
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Triggers')}</Text>
      <Text type="bodyMRegular">{t('Define los eventos que pueden disparar el envío de este email')}</Text>
      {triggers?.length > 0 && (
        <Styles.TriggersList>
          {triggers.map((trigger, index) => (
            <Styles.TriggerItem key={trigger.id}>
              {index > 0 && (
                <Styles.CombinatorContainer>
                  <CombinatorChip variant="OR" />
                </Styles.CombinatorContainer>
              )}
              <TriggerEvent
                selectedEvent={trigger.type}
                selectedValues={trigger.values}
                selectedInputValue={trigger[findEventConfig(trigger.type)?.inputOptions?.field] || ''}
                onChangeEvent={e => handleChangeEvent(trigger.id, trigger.type, e)}
                onChangeValues={e => handleChangeValues(trigger.id, e)}
                onChangeInputValue={e => handleChangeInputValue(trigger.id, trigger.type, e)}
                onRemove={() => onRemoveTrigger(trigger.id)}
                disabled={disabled}
                disabledTriggers={disabledTriggers}
                canRemove={triggers.length > 1}
                errors={errors.filter(error => error.triggerId === trigger.id)}
              />
            </Styles.TriggerItem>
          ))}
        </Styles.TriggersList>
      )}
      <Divider />
      <Styles.AddTriggerSection>
        <div>
          <Button variant="outlined" size="s" onClick={onAddTrigger} disabled={disabled}>
            <SparkleIcon size={16} />
            {t('Trigger')}
          </Button>
        </div>
      </Styles.AddTriggerSection>
    </Styles.Container>
  )
}

export default Trigger
